import { ReactNode } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { auth } from '../firebase';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AdminRouteProps {
  children: ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading } = useAuthStore();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen bg-app-bg flex items-center justify-center text-text-secondary">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-primary-accent border-t-transparent rounded-full animate-spin" />
          <p className="text-xs font-bold uppercase tracking-widest">Cargando...</p>
        </div>
      </div>
    );
  }

  const isBootstrapAdmin = user?.email === 'juansolisc@gmail.com' || auth.currentUser?.email === 'juansolisc@gmail.com';
  const isAdmin = user?.role === 'admin' || isBootstrapAdmin;

  if (!user || !isAdmin) {
    return (
      <div className="min-h-screen bg-app-bg flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-card-bg border border-grid-line/50 rounded-3xl p-8 text-center space-y-6 shadow-2xl">
          <div className="w-20 h-20 bg-rose-500/10 text-rose-500 rounded-full flex items-center justify-center mx-auto">
            <ShieldAlert size={40} />
          </div>
          <div>
            <h1 className="text-2xl font-black text-text-primary tracking-tight">Acceso Denegado</h1>
            <p className="text-sm text-text-secondary mt-2 font-medium">
              No tienes los permisos necesarios para acceder a esta zona restringida.
            </p>
          </div>
          <button 
            onClick={() => navigate('/')}
            className="w-full py-4 bg-primary-accent text-white rounded-2xl font-black flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
          >
            <ArrowLeft size={18} />
            VOLVER AL INICIO
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
